// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import FastClick from 'fastclick'
import App from './App'
import router from './router/index'
import store from './store/index'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import { getWechatSet, initAppData } from './service/getData'
import VueLazyload from 'vue-lazyload'

var locationUrl = location.href.split('#')[0]
locationUrl = locationUrl.split('?')[0]
const baseUrl = locationUrl.replace('/shuduier/', '')

store.dispatch('SET_BASEURL', baseUrl)

console.log(store.state.baseurl)

Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(WechatPlugin)
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: store.state.baseurl + '/style/imgs/book_loadimg.png',
    loading: store.state.baseurl + '/style/imgs/book_loadimg.png',
    attempt: 1,
    filter: {
        webp({ src }) {
            const isCDN = /http:/
            const isHttps = /https:/
            if (!(isCDN.test(src) || isHttps.test(src))) {
                src = store.state.baseurl + src
            }
            return src
        }
    }
})

Vue.use(ToastPlugin)
FastClick.attach(document.body)
Vue.config.productionTip = true

/**
 * 兼容微信设置页面的title
 */
let setDocumentTitle = function(title) {
    document.title = title;
    console.log(title)
    let ua = navigator.userAgent;
    if (/\bMicroMessenger\/([\d\.]+)/.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
        var i = document.createElement('iframe');
        i.src = '/favicon.ico';
        i.style.display = 'none';
        i.onload = function() {
            setTimeout(function() {
                i.remove();
            }, 9);
        };
        document.body.appendChild(i);
    }
};


//路由页面加载之前开启loading
router.beforeEach(function(to, from, next) {
        store.dispatch('UPDATE_LOADING_STATUS', { isLoading: true })
        next()
    })
    //路由页面加载完成之后关闭loading
router.afterEach(function(to) {
    store.dispatch('UPDATE_LOADING_STATUS', { isLoading: false })
})

//初始化应用数据
initAppData(store.state.baseurl).then(function(res) {
    store.dispatch('SET_ORGLOGO', res.data.orgLogo)
    store.dispatch('SET_ORGNAME', res.data.orgName)
    if (res.data.loginStatus) {
        //初始化登陆状态
        store.dispatch('SET_USER_LOGIN_IN');
        var user = res.data.user;
        //初始化性别
        if (user.gender == 1) {
            store.dispatch('SET_USER_SEX_MAN')
        } else if (user.gender == 2) {
            store.dispatch('SET_USER_SEX_WOMEN')
        } else {
            store.dispatch('SET_USER_SEX_DEFAULT')
        }
        //初始化昵称
        store.dispatch('SET_NICKNAME', user.nickname)
            //初始化name
        store.dispatch('SET_NAME', user.name)
            //初始化手机号
        store.dispatch('SET_MOBILE', user.mobile)
            //初始化头像
        if (user.avatar) {
            store.dispatch('SET_AVATAR', user.avatar)
        }
        //初始化绑定状态
        if (res.data.isBinding) {
            store.dispatch('SET_USER_BINDING_IN')
        } else {
            store.dispatch('SET_USER_BINDING_IN')
        }
    } else {
        store.dispatch('SET_USER_LOGIN_OUT')
    }
    setDocumentTitle(store.state.orgName + '-你看书我买单')
}).catch(function(err) {
    conolr.log(err)
})

getWechatSet(locationUrl).then(function(res) {
    var config = res.data
    Vue.wechat.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: config.appId, // 必填，公众号的唯一标识
        timestamp: config.timestamp, // 必填，生成签名的时间戳
        nonceStr: config.nonceStr, // 必填，生成签名的随机串
        signature: config.signature, // 必填，签名，见附录1
        jsApiList: ['scanQRCode', 'chooseWXPay', 'onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    });
})


/* eslint-disable no-new */
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app-box')


// WEBPACK FOOTER //
// ./src/main.js